import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import HeroText from '../HeroText';
import styles from './landing-hero.css';

const { section } = hh(h);

const LandingHero = () => (
    section({className: styles.container}, [
        h(HeroText, {
            page: 'landing',
            subTextSize: 'small',
            subText: 'Digital Skills Training for University Students',
            theme: 'white'}, [
                'Code at University'])])
);

export default LandingHero;



/** WEBPACK FOOTER **
 ** ./src/LandingHero/index.js
 **/